import { apiClient } from './client';

export interface PriceListAssignment {
  channelId: number | null;
  customerGroupId: number | null;
}

export interface PriceList {
  id: number;
  name: string;
  active: boolean;
  assignments: PriceListAssignment[];
}

export interface PriceListsResponse {
  priceLists: PriceList[];
  bcAdminUrl: string;
}

export const pricelistsApi = {
  async list(): Promise<PriceListsResponse> {
    return apiClient.request('/pricelists');
  },
};
